import React, { useEffect, useState } from 'react';


const Argitech4 = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  return (
   <div className='bg-white '>
     <div className='px-4 md:px-40 pt-3'>
     <h1 className="text-[14px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">AgriTech</h1>
      <h1 className="text-[12px] md:text-[32px] font-bold mb-4 text-black">Revolutionizing Agriculture with Digital solutions</h1>

      <div className="relative w-full  overflow-hidden  rounded-lg bg-white">
        <div className="relative w-full rounded-lg">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-[#742B3E] border-solid"></div>
            </div>
          )}
          <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
              alt="Play"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[133px] md:h-[133px] z-10"
            />
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745008803/image_35_d1uume.png"
            alt="Securing Agriculture in Namibia"
            className={`w-full md:h-[622px] object-cover   rounded-lg transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
            onLoad={() => setIsLoading(false)}
          />
          {!isLoading && (
            <div className="absolute md:bottom-2 bottom-6 md:left-0 w-full px-4">
            <h2 className="text-white   md:text-[24px] font-bold mb-2">FOOD SECURITY</h2>
                <h2 className="text-white text-[14px] md:text-[40px] font-bold -mt-3" style={{ lineHeight: '1.20' }}>
                  Innovation for Sustainable <br /> Future
                </h2>
            </div>
          )}
        </div>
      </div>
      <div className="md:mt-5  mt-2 md:space-y-7 space-y-5 text-[12px] md:text-[42px] text-black font-normal leading-tight">
  {/* ...existing content here... */}
  <div className="mt-5 max-w-screen-xl w-full">
            <h3 className="text-black font-normal text-[14px] md:text-[30px] mb-1">April 13, 2025</h3>
            <div className="flex items-center gap-6 md:gap-8 text-[13px] md:text-[30px] font-normal text-black">
              <p>Story by Editorial team</p>
              <div className="flex items-center gap-2 text-[#155528]">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
                  alt="Clock"
                  className="h-6 w-6 md:h-8 md:w-8"
                />
                <p>2 Minutes read</p>
              </div>
            </div>
          </div>

          
    <div className=" font-sans text-[10px] md:text-[32px] text-gray-800 space-y-16">
    <h2 className="font-bold mb-6">#FarmingIsCool</h2>

    <h2 className="font-bold mb-6">We are making farming cool by rebrand farming to make it cool, modern, and empowering for the youth:</h2>
      
      <div>
        <h2 className="font-bold mb-6">🚜 1. Tech-Driven Farming</h2>
        <ul className="list-disc md:ml-20 ml-8 space-y-4">
          <li><span className="font-bold">Smart Farming = Smart Life</span>: We are showcasing modern tools like drones, solar-powered irrigation, hydroponics, and apps for weather, markets, and soil testing.</li>
          <li>Partnering with agritech companies to host workshops or demos at schools and universities.</li>
          </ul>
          <span className="font-bold">“It’s not just a hoe and a cow anymore. It’s GPS, data, and drones.”</span>

      </div>

      <div>
        <h2 className="font-bold mb-6">📲 2. Social Media Influence</h2>
        <ul className="list-disc md:ml-20 ml-8  space-y-4">
          <li>We are building social media campaigns (Instagram, TikTok, YouTube) showing the lifestyle of young, successful Namibian farmers.</li>
          <li>Use hashtags like #CoolToFarm,#GreenIsGold, #FarmingGoals.</li>
          <li>Highlight the <strong>“farmpreneur” </strong> life—income, independence, impact.</li>
        </ul>
      <span className="font-bold">Think: “Farming as the new hustle.”</span>

      </div>

      <div>
        <h2 className="font-bold mb-6">🎓 3. Youth Programs & Role Models</h2>
        <ul className="list-disc md:ml-20 ml-8  space-y-4">
          <li>We are celebrating local agri-heroes—young Namibians killing it in farming—to give talks or do collabs with influencers.</li>
          <li>Setting up mentorship programs, internships, and startup grants for agribusiness ideas.</li>
        </ul>
      </div>

      <div>
        <h2 className="font-bold mb-6">💼 4. Money Talks: Show the Business Side</h2>
        <ul className="list-disc md:ml-20 ml-8  space-y-4">
          <li>We are teaching farming as a business: managing costs, selling to supermarkets, branding farm products.</li>
          <li>Case studies: “This 23-year-old makes $10K a year from goats and tomatoes.”</li>
        </ul>
<span className="font-bold">Farming isn’t just growing—it’s growing wealth.</span>

      </div>

      <div>
        <h2 className="font-bold mb-6">🎨 5. Style & Culture</h2>
        <ul className="list-disc md:ml-20 ml-8  space-y-4">
          <li>We are fusing farming with music, art, and fashion—merchandise, collabs with local designers, events like “Farm Fest”.</li>
          <li>Photo shoots in fields with stylish outfits—rural aesthetic with an edge.</li>
        </ul>
        <span className="font-bold">“It’s giving earthy drip.” 🌾🔥</span>

      </div>

      <div>
        <h2 className="font-bold mb-6">🌍 6. Climate Champions</h2>
        <ul className="list-disc md:ml-20 ml-8  space-y-4">
          <li>We are positioning young farmers as climate warriors—restoring land, saving water, growing food sustainably.</li>
          <li>Promote eco-conscious farming and connect it to national pride.</li>
        </ul>
      </div>

      <div className="font-bold">
        We are building a campaign, slogan, mapping out social content and workshop ideas for youth in Namibia to make Farming cool.
      </div>
    </div>

  <div className="md:h-5 h-2"></div>
</div>


    </div>
   </div>
  );
};

export default Argitech4;
